export default __webpack_public_path__ + "static/media/11.d67b5523.png";